import React, { Fragment, useEffect, useState, useCallback } from "react";
import { Menu } from "antd";
import * as Icons from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import useStores, { observer } from "stores";
import { useDisMenuList } from "hooks/services/common";
import { ToastMsg } from "utils/commonUtil";
import Loading from "components/common/loading";

function MenuList() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [selectedKeys, setSelectedKeys] = useState([pathname]);
  const { commonStore } = useStores();
  const { menuList, setMenuList, defaultMenu, setDefaultMenu } = commonStore;

  const { isLoading: isLoadingMenu, mutateAsync: disMenuList } = useDisMenuList({
    onSuccess: async (data) => {
      if (data?.error?.code === "0000") {
        await setDefaultMenu(data?.result?.[0]?.menuCode);
        const resultMenuList = menuLoop(data.result || []);
        await setMenuList(resultMenuList);
      } else {
        ToastMsg("error", `메뉴목록 조회에 실패했습니다.`);
      }
    },
  });

  useEffect(() => {
    if (menuList?.length <= 0) {
      disMenuList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const urlArry = pathname?.split("/").slice(1);
    setSelectedKeys([(urlArry?.length > 0 && urlArry[0]) || defaultMenu]);
  }, [pathname]);

  const getMenuItem = (label, key, icon, path, children = null, type = null) => {
    return { key, icon, children, label, type, path, title: label };
  };

  const addIcon = (name) => {
    return name ? React.createElement(Icons[name]) : null;
  };

  const menuLoop = useCallback((menuList, newArr = []) => {
    menuList.forEach((item) => {
      if (!item.menuChildren?.length) {
        return newArr.push(getMenuItem(item.menuName, item.menuCode, addIcon(item.menuImg), item.menuPath));
      }
      newArr.push(
        getMenuItem(item.menuName, item.menuCode, addIcon(item.menuImg), item.menuPath, menuLoop(item.menuChildren))
      );
    });
    return newArr;
  }, []);

  const onSelect = ({ keyPath }) => {
    console.log("onSelect keyPath:", keyPath);
    if (keyPath?.length === 1) {
      navigate("/" + keyPath[0]);
    } else {
      navigate("/" + keyPath[1] + "/" + keyPath[0]);
    }
  };

  return (
    <Fragment>
      <Loading loading={isLoadingMenu || menuList.length <= 0}>
        {!isLoadingMenu && menuList.length > 0 && (
          <Menu
            theme="light"
            onSelect={onSelect}
            mode="inline"
            selectedKeys={selectedKeys}
            defaultOpenKeys={["/" + defaultMenu]}
            style={{ height: "auto", borderRight: 0, overflow: "auto" }}
            items={menuList}
            className="menu"
          />
        )}
      </Loading>
    </Fragment>
  );
}

export default observer(MenuList);
